/** H5 启动页：index.html 内联 #splash-screen，App 就绪后淡出移除 */
const MIN_SHOW_MS = 2200
const FADE_MS = 480

let hideStarted = false

export function hideBootSplash(): void {
  if (hideStarted || typeof document === 'undefined') return
  hideStarted = true
  const el = document.getElementById('splash-screen')
  if (!el) return
  el.classList.add('splash-screen--hide')
  window.setTimeout(() => el.remove(), FADE_MS)
}

/** 保证启动页至少展示 MIN_SHOW_MS，再淡出 */
export async function hideBootSplashAfterReady(startedAt: number): Promise<void> {
  const elapsed = Date.now() - startedAt
  const remain = Math.max(0, MIN_SHOW_MS - elapsed)
  if (remain > 0) {
    await new Promise<void>((resolve) => window.setTimeout(resolve, remain))
  }
  hideBootSplash()
}
